/* Techsite product page: photo gallery, full-screen viewer, and the option buttons that keep the
   price, stock, photo and Add to cart in step. No library, no build step. */
(function () {
  var COLOURS = {black:'#1d1d1f',white:'#f5f5f0',silver:'#e3e4e5',gold:'#f3d9b1','space gray':'#5c5c60','space grey':'#5c5c60',
    'space black':'#2e2c2e',midnight:'#232a31',starlight:'#f0e8db',blue:'#3b6fb6',red:'#c8102e','(product)red':'#c8102e',
    green:'#3f6b4f',pink:'#f4c9cf',purple:'#b9a6d6','deep purple':'#4b3a52',yellow:'#f9e27c',graphite:'#4f4e4c',
    'sierra blue':'#9bb5ce','alpine green':'#4b5a4a','natural titanium':'#bfb9ae','black titanium':'#3c3b39',
    'white titanium':'#e8e6e1','blue titanium':'#3f4a5a','desert titanium':'#c6a98c','cosmic orange':'#e5732f',
    'deep blue':'#2a3a5e','mist blue':'#a9bfd6',lavender:'#c9bde3',sage:'#b7c2a5',ultramarine:'#5568d8',teal:'#6fa8a2',
    'deep black':'#121214','glacier blue':'#b9d3e6',burgundy:'#6a1f2e','onyx black':'#222','marble grey':'#c9c9c9',
    'cobalt violet':'#6a5acd','amber yellow':'#e8c25a','titanium gray':'#8a8d8f','titanium black':'#2f2f30',
    'titanium violet':'#7d6b8f','titanium yellow':'#d9c37a','titanium silverblue':'#a8b7c6','phantom black':'#1f1f1f',
    cream:'#efe6d2',lime:'#cfe27a','sky blue':'#bcd6ea','light gold':'#ead8b5','cloud white':'#f4f4f2',
    'soft pink':'#f3d4d8','rose gold':'#e7c1b3',coral:'#ff7f6b',orange:'#f08a3c',navy:'#1f2e57',grey:'#8e8e93',gray:'#8e8e93'};

  function gallery(root) {
    var mainImg = root.querySelector('.ts-gallery__zoom img');
    var zoom = root.querySelector('[data-ts-zoom]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ts-thumb]'));
    var strip = root.querySelector('[data-ts-thumbs]');
    var idx = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
    var lb = null, lastFocus = null;
    function setMain(src, full) {
      if (!mainImg || !src) return;
      idx = thumbs.findIndex(function (t) { return t.getAttribute('data-ts-thumb') === src; });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      if (idx > -1 && strip) {
        var t = thumbs[idx];
        if (strip.scrollHeight > strip.clientHeight + 2) {
          var top = t.offsetTop - strip.offsetTop;
          if (top < strip.scrollTop || top + t.offsetHeight > strip.scrollTop + strip.clientHeight) strip.scrollTo({ top: top - 8, behavior: 'smooth' });
        } else {
          var l = t.offsetLeft - strip.offsetLeft;
          if (l < strip.scrollLeft || l + t.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: l - 10, behavior: 'smooth' });
        }
      }
      if (zoom) zoom.setAttribute('data-ts-full', full || (idx > -1 ? thumbs[idx].getAttribute('data-ts-full') : src));
      if (mainImg.getAttribute('src') === src && !mainImg.hasAttribute('srcset')) return;
      mainImg.classList.add('is-loading');
      var pre = new Image();
      pre.onload = pre.onerror = function () { mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = src; mainImg.classList.remove('is-loading'); };
      pre.src = src;
    }
    function show(i) { if (!thumbs.length) return; i = (i + thumbs.length) % thumbs.length; setMain(thumbs[i].getAttribute('data-ts-thumb'), thumbs[i].getAttribute('data-ts-full')); if (lb && !lb.hidden) lbShow(); }
    function step(d) { show((idx < 0 ? 0 : idx) + d); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    root.querySelectorAll('[data-ts-nav]').forEach(function (b) { b.addEventListener('click', function () { step(parseInt(b.getAttribute('data-ts-nav'), 10)); }); });
    var sx = null, swiped = false;
    if (zoom) {
      zoom.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; swiped = false; }, { passive: true });
      zoom.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 45 && thumbs.length > 1) { swiped = true; step(dx < 0 ? 1 : -1); } }, { passive: true });
      zoom.addEventListener('click', function () { if (swiped) { swiped = false; return; } openLb(); });
    }
    function lbShow() {
      var img = lb.querySelector('img');
      img.src = idx > -1 ? thumbs[idx].getAttribute('data-ts-full') : zoom.getAttribute('data-ts-full');
      img.alt = mainImg ? mainImg.alt : '';
      lb.querySelector('.ts-lb__count').textContent = thumbs.length > 1 && idx > -1 ? (idx + 1) + ' / ' + thumbs.length : '';
      lb.querySelectorAll('.ts-lb__nav').forEach(function (n) { n.hidden = thumbs.length < 2; });
    }
    function closeLb() { lb.hidden = true; document.documentElement.classList.remove('ts-lb-open'); if (lastFocus) lastFocus.focus(); }
    function openLb() {
      if (!lb) {
        lb = document.createElement('div'); lb.className = 'ts-lb'; lb.hidden = true;
        lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Product photos');
        lb.innerHTML = '<button type="button" class="ts-lb__close" aria-label="Close">✕</button>' +
          '<button type="button" class="ts-lb__nav ts-lb__nav--prev" aria-label="Previous photo">‹</button><img alt="">' +
          '<button type="button" class="ts-lb__nav ts-lb__nav--next" aria-label="Next photo">›</button><span class="ts-lb__count"></span>';
        document.body.appendChild(lb);
        lb.addEventListener('click', function (e) {
          var b = e.target.closest('button');
          if (e.target === lb || (b && b.classList.contains('ts-lb__close'))) return closeLb();
          if (b && b.classList.contains('ts-lb__nav--prev')) step(-1);
          if (b && b.classList.contains('ts-lb__nav--next')) step(1);
        });
        var lx = null;
        lb.addEventListener('touchstart', function (e) { lx = e.touches[0].clientX; }, { passive: true });
        lb.addEventListener('touchend', function (e) { if (lx === null) return; var dx = e.changedTouches[0].clientX - lx; lx = null; if (Math.abs(dx) > 45) step(dx < 0 ? 1 : -1); }, { passive: true });
        document.addEventListener('keydown', function (e) { if (lb.hidden) return; if (e.key === 'Escape') closeLb(); else if (e.key === 'ArrowLeft') step(-1); else if (e.key === 'ArrowRight') step(1); });
      }
      lastFocus = document.activeElement; lbShow(); lb.hidden = false; document.documentElement.classList.add('ts-lb-open'); lb.querySelector('.ts-lb__close').focus();
    }
    return { setMain: setMain, thumbFor: function (colour) {
      colour = (colour || '').toLowerCase();
      var t = thumbs.find(function (x) { return colour && (x.getAttribute('data-alt') || '').toLowerCase().indexOf(colour) > -1; });
      return t ? t.getAttribute('data-ts-thumb') : null;
    } };
  }

  function init(root) {
    if (root.dataset.tsReady) return; root.dataset.tsReady = '1';
    var variants = JSON.parse(root.querySelector('[data-ts-variants]').textContent);
    var fmt = JSON.parse(root.querySelector('[data-ts-money]').textContent);
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-ts-option]'));
    var idInput = root.querySelector('[data-ts-variant-id]');
    var add = root.querySelector('[data-ts-add]');
    var addLabel = add ? add.querySelector('span') : null;
    var priceEl = root.querySelector('[data-ts-price]');
    var wasEl = root.querySelector('[data-ts-was]');
    var compareEl = root.querySelector('[data-ts-compare]');
    var saveEl = root.querySelector('[data-ts-save]');
    var stockEl = root.querySelector('[data-ts-stock]');
    var qty = root.querySelector('[data-ts-qty]');
    var skuEl = root.querySelector('[data-ts-sku]');
    var barcodeEl = root.querySelector('[data-ts-barcode]');
    var battRow = root.querySelector('[data-ts-battery-row]');
    var batt = root.querySelector('[data-ts-battery]');
    var gal = gallery(root);
    var current = variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];
    var chosen = current ? current.options.slice() : [];
    var lastImg = null;
    function money(cents) { var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); return fmt.replace(/\{\{\s*\w+\s*\}\}/, n); }
    function match(opts, upto) { return variants.filter(function (v) { for (var i = 0; i < opts.length; i++) { if ((upto === undefined || i < upto) && opts[i] != null && v.options[i] !== opts[i]) return false; } return true; }); }
    function best(list) { var avail = list.filter(function (v) { return v.available; }); var pool = avail.length ? avail : list; return pool.slice().sort(function (a, b) { return a.price - b.price; })[0]; }
    function render(first) {
      current = variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
      groups.forEach(function (g, gi) {
        g.querySelector('[data-ts-chosen]').textContent = chosen[gi] || '';
        g.querySelectorAll('[data-value]').forEach(function (btn) {
          var val = btn.getAttribute('data-value'); var probe = chosen.slice(); probe[gi] = val;
          var list = match(probe, gi + 1); var avail = list.filter(function (v) { return v.available; });
          btn.setAttribute('aria-pressed', String(val === chosen[gi])); btn.classList.toggle('is-out', !avail.length);
          var state = btn.querySelector('[data-ts-state]'); if (state) state.textContent = avail.length ? '' : 'Sold out';
          var cp = btn.querySelector('[data-ts-cond-price]'); if (cp) { var b = best(list); cp.textContent = b ? (avail.length ? money(best(avail).price) : money(b.price)) : ''; }
          var dot = btn.querySelector('.ts-swatch__dot'); if (dot) { var c = COLOURS[dot.getAttribute('data-colour')] || COLOURS[(dot.getAttribute('data-colour') || '').split(' ').pop()]; if (c) dot.style.setProperty('--sw', c); }
        });
      });
      if (!current) return;
      idInput.value = current.id; priceEl.textContent = money(current.price);
      if (wasEl) {
        var onSale = current.compare && current.compare > current.price;
        wasEl.hidden = !onSale;
        if (onSale) { if (compareEl) compareEl.textContent = money(current.compare); if (saveEl) saveEl.textContent = 'Save ' + money(current.compare - current.price); }
      }
      stockEl.textContent = current.available ? (current.tracked && current.qty <= 2 ? 'Hurry, only ' + current.qty + ' left' : 'In stock') : 'Sold out';
      stockEl.classList.toggle('is-out', !current.available);
      add.disabled = !current.available;
      if (addLabel) addLabel.textContent = current.available ? 'Add to cart' : 'Sold out';
      if (qty) qty.max = current.tracked ? Math.max(1, current.qty) : 10;
      if (skuEl && current.sku) skuEl.textContent = current.sku;
      if (barcodeEl && current.barcode) barcodeEl.textContent = current.barcode;
      if (battRow) { battRow.hidden = !current.battery; if (batt) batt.textContent = current.battery || ''; }
      var colourIdx = groups.findIndex(function (g) { return /colou?r/i.test(g.getAttribute('data-name')); });
      var img = current.image || (colourIdx > -1 ? gal.thumbFor(chosen[colourIdx]) : null);
      if (img && img !== lastImg) { lastImg = img; if (!first) gal.setMain(img); }
      if (!first) { var url = new URL(window.location.href); url.searchParams.set('variant', current.id); window.history.replaceState({}, '', url.toString()); }
    }
    groups.forEach(function (g, gi) {
      g.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]'); if (!btn) return;
        chosen[gi] = btn.getAttribute('data-value');
        var exact = variants.find(function (v) { return v.available && v.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!exact) { var b = best(match(chosen, gi + 1)); if (b) chosen = b.options.slice(); }
        render(false);
      });
    });
    var printBtn = root.querySelector('[data-ts-print]');
    if (printBtn) printBtn.addEventListener('click', function () { window.print(); });
    render(true);
  }
  function all() { document.querySelectorAll('[data-ts-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-ts-pdp]'); if (r) init(r); });
})();
